import GovernmentNumbersBody from './GovernmentNumbersBody';

const View = (props) => <GovernmentNumbersBody {...props} />;

export default View;
